/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconTrail: {
  name: 'trail';
  data: string;
} = {
  name: 'trail',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M720.034 750.736c-36.947 1.758-495.769-.988-495.769-.988-278.745-279.911 419.683-372.564-12.006-602.465l-30.208 31.847-40.222-105.552 129.807 10.106-25.988 29.196c539.908 157.331-72.594 452.209 474.386 637.856z" transform="translate(-20.892 -32.587) scale(.83024)"/></svg>`,
};
